import './index.less';

const Label = ({ hidden, status, children }) => {
    if (hidden) return null;
    let labelClass;
    if (status) {
        const statusStripped = status.startsWith('label-') ? status.slice(6) : status;
        labelClass = `label label-${statusStripped}`;
    } else {
        labelClass = 'label-tag';
    }
    return <span className={labelClass}>{children}</span>;
};

Label.defaultProps = {
    hidden: false,
};

export default Label;
